import { UserPermissions } from '../../../components/User';
import { UserType } from '../../../types';

export function InternalUserPermissions() {
  return <UserPermissions type={UserType.Internal} />;
}
